import {GridResourceCollectionInterface} from "../../../store/interfaces/GridResourceCollectionInterface";
import {
    apiTeamsGet,
    apiTeamsPost,
    apiTeamsTeamPut,
    CollectionResponse,
    TeamOutput,
    TeamUpdateInput
} from "../../../generated";
import {action, observable} from "mobx";
import UiBus from "../../../store/service/UiBus";
import {handleFormSubmit} from "../../../utils/form/handleFormSubmit";
import {v4} from 'uuid';

export class TeamStore implements GridResourceCollectionInterface<TeamOutput> {
    @observable collectionResponse: CollectionResponse<TeamOutput> | null = null
    @observable isLoading = false;
    @observable isModalOpen = false;
    @observable model?: TeamOutput;

    constructor(private uiBus: UiBus) {}

    @action fetchCollection(query): void {
        this.isLoading = true;
        apiTeamsGet()
            .then(action((response) => {
                this.collectionResponse = response;
            }))
            .finally(action(() => {
                this.isLoading = false;
            }))
            .catch((error) => {
                this.uiBus.notify("Something went wrong", "warning");
            })
    }

    @action selectTeam(team: TeamOutput) {
        this.model = team;
        this.isModalOpen = true;
    }

    @action openNewTeamModal() {
        this.isModalOpen = true;
    }

    @action closeTeamModal() {
        this.isModalOpen = false;
        this.model = undefined;
    }

    @action toggleLoading(): void {
        this.isLoading = !this.isLoading;
    }

    @action
    async submit(values: TeamUpdateInput) {
        if (this.model) {
            const result = await handleFormSubmit(apiTeamsTeamPut(this.model.id, {
                manager: values.manager,
                members: values.members,
                name: values.name,
            }))
            if (result.errors) {
                this.uiBus.notify("Something went wrong", "warning");
                return result.errors;
            }
        } else {
            const result = await handleFormSubmit(apiTeamsPost({
                id: v4(),
                manager: values.manager,
                members: values.members,
                name: values.name,
            }))
            if (result.errors) {
                this.uiBus.notify("Something went wrong", "warning");
                return result.errors;
            }
        }
        this.closeTeamModal();
        this.fetchCollection({});
    }
}